import { Component, OnInit } from "@angular/core";
import { FormArray, FormBuilder, FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { RecordTitleSet } from "@app/models/record.model";
import { SelectTitles, SetTitleSetList } from "@app/store/setting/setting.classes";
import { SettingSelectors } from "@app/store/setting/setting.selectors";
import { SpinnerSelectors } from "@app/store/spinner/spinner.selectors";
import { Select, Store } from "@ngxs/store";
import { Observable } from "rxjs";

@Component({
    selector: 'app-user-title-select',
    templateUrl: './user-title-select.component.html',
})
export class UserTitleSelectComponent implements OnInit {
    titleSetList!: RecordTitleSet[];
    form!: FormGroup;
    historyBackWard = () => history.back();

    @Select(SpinnerSelectors.isLoading) isLoading$!: Observable<boolean>;
    isLoading: boolean = false;

    constructor(
        private readonly store: Store,
        private readonly fb: FormBuilder,
        private router: Router,
    ) {
    }

    ngOnInit(): void {
        this.isLoading$.subscribe(isLoading => this.isLoading = isLoading);
        this.store.dispatch(new SelectTitles({ items: [] }))
        this.store.dispatch(new SetTitleSetList('list'));
        this.titleSetList = this.store.selectSnapshot(SettingSelectors.titleSetList);
        this.form = this.fb.group({
            titleSetList: this.fb.array(
                this.titleSetList.map((titleSet) =>
                    this.fb.array(titleSet.titles.map(() => null))
                )
            ),
        });
    }

    getForm(index: number) {
        return this.titleSetListForm.at(index) as FormArray;
    }

    onSubmit(): void {
        const records = this.titleSetList.map((titleSet, i) =>
            titleSet.titles.filter((_, j) => !!this.titleSetListForm.value[i][j])
        );
        this.store
            .dispatch(new SelectTitles({ items: records.flat() }))
            .subscribe(() =>
                this.router.navigate(['home','records-create'])
                // this.router.navigate(['', { outlets: { edit: ['record-add'] } }], { replaceUrl: true, queryParamsHandling: "preserve" })
            );
    }

    private get titleSetListForm() {
        return this.form.get('titleSetList') as FormArray;
    }
}
